export default __webpack_public_path__ + "static/media/blocklistwhite.6b043125.svg";